import Collect from './Collect'
import UploadPaymentForPoint from './UploadPaymentForPoint'
import selectPayment from './selectPayment'

export default {
  Collect,
  UploadPaymentForPoint,
  selectPayment
}



// WEBPACK FOOTER //
// ./src/components/Point/index.js